<template>
  <CSidebar 
    :visible="show"
    class="position-fixed sidebar-custom"
  >
    <CSidebarHeader class="sidebar-header-fixed border d-flex align-items-center justify-content-center">
      <CSidebarBrand to="/" class="text-center">
        <router-link to="/">
          <img src="/img/logo.png" width="118" height="46" alt="Logo" />
        </router-link>
      </CSidebarBrand>
    </CSidebarHeader>
    <CSidebarNav class="border sidebar-nav-scroll">
      <MenuItems/>
    </CSidebarNav>
  </CSidebar>
</template>

<script>
import nav from './_nav'
import MenuItems from './MenuItems'
import { emitter } from '../../helpers/emitter';
import { CSidebar, CSidebarBrand, CSidebarHeader, CSidebarNav } from '@coreui/vue';

export default {
  name: 'Sidebar',
  components: {
    CSidebarHeader,
    CSidebar,
    CSidebarBrand,
    CSidebarNav,
    MenuItems
  },
  data () {
    return {
      minimize: false,
      nav,
      show: true,
    }
  },
  mounted () {
    emitter.on('toggle-sidebar', () => {
      this.show = !this.show
    })
  },
}
</script>

<style scoped>
.sidebar-custom {
  height: 100vh;
  display: flex;
  top: 0;
  left: -12px;
  flex-direction: column;
}

.sidebar-header-fixed {
  flex: 0 0 auto;
  border-bottom: 1px solid #dee2e6;
  height: 8vh

}

.sidebar-nav-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  height: 92vh;
}

.sidebar-custom {
  --cui-sidebar-nav-link-hover-color: white;
  --cui-sidebar-nav-link-hover-bg: #321fdb;
  --cui-sidebar-nav-link-hover-icon-color: white;
}

:deep(.sidebar-nav .nav-group.show) {
  background-color: #9999A1 !important;
}

:deep(.nav-group.show svg.nav-icon) {
  color: white !important;
}

:deep(.sidebar-nav .nav-group.show .nav-group-toggle) {
	color: white;
}

:deep(.sidebar-nav .nav-group-items .nav-link) {
  color: white;
}

:deep(.sidebar-nav .nav-group:hover .nav-group-toggle::after) {
  background-color: white;
}

:deep(.sidebar-nav .nav-group.show .nav-group-toggle::after) {
  background-color: white;
}

</style>
